import { render, staticRenderFns } from "./LawEnforcement.vue?vue&type=template&id=7b2d2553&"
import script from "./LawEnforcement.vue?vue&type=script&lang=js&"
export * from "./LawEnforcement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports